<template>
    <ModalIndex
        v-model:visible="showDeleteClientModal"
        :eventToCloseFunction="clearDeleteClientRefs"
        footer-class="justify-end"
        fullscreen-on-mobile
        title="Delete Client from EMD"
    >
        <p
            v-if="error"
            class="text-danger rounded-md bg-ds-red-100 px-6 py-4 text-base"
        >
            There was an error deleting this record. Please try again, or contact support if you continue to experience the
            problem.
        </p>

        <div class="grid grid-cols-2 gap-y-2">
            <span>Client Name</span>
            <span>{{ clientRef?.first }} {{ clientRef?.last }}</span>

            <span>Client Email</span>
            <span>{{ clientRef?.email }}</span>
        </div>

        <template #footer>
            <button
                class="bg-danger rounded-md px-6 py-4 text-white"
                :disabled="!emdRef || !clientRef"
                @click="confirmDelete"
            >
                Confirm
            </button>
            <button
                class="rounded-md px-6 py-4"
                @click="clearDeleteClientRefs"
            >
                Cancel
            </button>
        </template>
    </ModalIndex>
</template>

<script setup lang="ts">
import ModalIndex from '@/components/Components/Modal/ModalIndex.vue';
import { useDeleteClientEarlyDeposit } from '@/services/early-deposit.service';
import type { Client } from '@/types/closinglock.types';
import { computed } from 'vue';

const showDeleteClientModal = computed<boolean>({
    get: () => !!emdRef.value && !!clientRef.value,
    set: flag => {
        !flag && clearDeleteClientRefs();
    },
});

const emit = defineEmits<{
    emdClientDeleted: [deleteClientRef: Client['id']];
}>();

const { error, emdRef, clientRef, clearDeleteClientRefs, runDelete } = useDeleteClientEarlyDeposit();

const confirmDelete = async () => {
    await runDelete();
    if (error.value) return;
    emit('emdClientDeleted', `${clientRef.value!.id}`);
    clearDeleteClientRefs();
};
</script>
